package com.siriusxm.pia.operations.dashboard

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

/**
 * A horizontal band within a [Dashboard].
 *
 * Children (usually [Widget]s) are distributed across a notional 12 columns using flexbox.
 * A widget occupies a share of the row proportional to its `span`, and reflows onto a new
 * line — expanding to fill it — once the viewport is narrower than the widget's declared
 * `minWidth`. Widgets in the same row reflow independently based on their own `minWidth`
 * values, so a three-widget row can collapse to two columns and then to one as space shrinks.
 *
 * @param gap horizontal (and, when wrapped, vertical) spacing between widgets. Defaults to
 *   `1rem` to match the dashboard's row spacing.
 * @param content the widgets in this row.
 */
@Composable
fun Row(
    gap: CSSNumeric = 1.cssRem,
    content: @Composable () -> Unit
) {
    Div({
        classes(DashboardStyles.row)
        style { gap(gap) }
    }) {
        content()
    }
}
